import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EventIcon } from "@faire/retailer-visitor-shared/components/Events/shared/EventIcon";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { getEventTheme } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import myMarketList from "@faire/web-api--source/routes/markets/event_type/all-specials/my-market-list";
import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
export var MarketNavElements = function(param) {
    var regularFont = param.regularFont, textColor = param.textColor, onClick = param.onClick;
    var currentEventType = useMarketStore([
        "currentEventType"
    ]).currentEventType;
    return /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(EventIcon, {
                size: "20px"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(Link, {
                "data-test-id": "market-nav-elements-link",
                to: myMarketList(currentEventType),
                onClick: onClick,
                children: /*#__PURE__*/ _jsx(StyledTypography, {
                    "data-test-id": "market-nav-elements-typography",
                    variant: regularFont ? "paragraphSansRegular" : "paragraphSansMedium",
                    color: textColor !== null && textColor !== void 0 ? textColor : getEventTheme("faireMarket").promoText,
                    $textColor: textColor !== null && textColor !== void 0 ? textColor : getEventTheme("faireMarket").promoText,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "wSIv9T",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "My market list"
                            }
                        ]
                    })
                })
            })
        ]
    });
};
var StyledTypography = styled(Typography).attrs({
    truncate: true
}).withConfig({
    componentId: "sc-9bf482a1-0"
})([
    "&:hover,&:focus,&:focus-within{color:",
    ";}"
], function(param) {
    var $textColor = param.$textColor;
    return $textColor;
});
